import { Map, fromJS } from 'immutable';

export function update(state, action) {
    return state.set(
        'data',
        (state.get('data') || Map()).merge(action.user)
    );
}
